<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">用户管理</div> -->
    <div class="div-top">
      <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >新建菜单/页面</el-button
      >
      <!-- <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      >
      <el-input
        v-model="searchData.Keyword"
        placeholder="请输入用户编号/姓名"
        clearable
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      > -->
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        row-key="Id"
        :tree-props="{ children: 'Children' }"
      >
        <el-table-column label="页面名称" align="left" prop="title">
        </el-table-column>
        <el-table-column label="菜单/页面" align="center" prop="Type">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.Type == 0">菜单</el-tag>
            <el-tag v-if="scope.row.Type == 1" type="success">页面</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="路径URL" align="center" prop="Url">
        </el-table-column>
        <el-table-column label="图标" align="center" prop="icon">
          <template slot-scope="scope">
            <i :class="scope.row.icon"></i>
          </template>
        </el-table-column>
        <el-table-column
          label="左侧菜单类型"
          align="center"
          prop="TreeDataType"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.TreeDataType == 0" type="info">无</el-tag>
            <el-tag v-if="scope.row.TreeDataType == 1">楼号设备分类</el-tag>
            <el-tag v-if="scope.row.TreeDataType == 2">备件分类</el-tag>
            <el-tag v-if="scope.row.TreeDataType == 3">资产分类</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="排序" align="center" prop="Sort">
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
  </div>
</template>
<script>
import EditForm from './EditForm'
export default {
  data() {
    return {
      searchData: {
        Keyword: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { EditForm },
  methods: {
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base_Manage/Base_Action/GetMenuTreeList', {})
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建菜单/页面', null, this.tableData)
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该菜单/页面, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/Base_Manage/Base_Action/DeleteData', ids)
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.EditForm.openForm('编辑用户', row, this.tableData)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
